/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyNotificationsIcon = createIcon("EmptyNotificationsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M69.084 83.817 48.37 79.11l-4.67 5.506c-.715.843-2.16 1.29-3.218 1.002l-8.467-2.305c-1.063-.29-2.036-1.418-2.173-2.514l-.759-6.073-2.136-.485C25.872 73.996 25 72.9 25 71.808V57.192c0-1.1.878-2.19 1.947-2.433l42.137-9.576a4 4 0 017.916.823v36.989a4 4 0 01-7.916.823ZM31.785 80.22c.069.548.558 1.11 1.081 1.253l7.88 2.145c.53.144 1.25-.084 1.606-.504l3.814-4.496-14.998-3.333.617 4.935Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 65.203c0 .552.443 1.1.976 1.22L75 75.748V41.253l-41.024 9.323c-.539.123-.976.667-.976 1.221v13.406Zm44-26.456v39.506L32.947 68.24C31.872 67.996 31 66.9 31 65.808V51.192c0-1.1.878-2.19 1.947-2.433L77 38.747Zm-42.168 27.97 21.002 4.666-6.134 7.233c-.715.843-2.16 1.29-3.218 1.002l-8.467-2.305c-1.063-.29-2.036-1.418-2.173-2.514l-1.01-8.083Zm2.953 7.502c.069.548.558 1.11 1.081 1.253l7.88 2.146c.53.143 1.25-.085 1.606-.505l3.814-4.496-14.998-3.333.617 4.935Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 65.203c0 .551.443 1.1.976 1.22L75 75.748V41.253l-41.024 9.323c-.539.123-.976.666-.976 1.22v13.407Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 37h-2a2 2 0 00-2 2v39a2 2 0 002 2h2a2 2 0 002-2V39a2 2 0 00-2-2Z",
    fill: "#A5AEFF",
    stroke: "#0C0D0D",
    strokeWidth: "2"
  }));
}, {
  "i18nKey": "svg.EmptyNotificationsIcon"
});